import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CommentBouldersSector, GymMinimalProps } from '../constants/types';
import { getGymComments } from '../data/getAxiosRequests';

interface UseCommentsPageDataReturn {
    comments: CommentBouldersSector[];
    isLoading: boolean;
}

export function useCommentsPageData(
    user: string | null,
    currentGym: GymMinimalProps | null,
): UseCommentsPageDataReturn {
    const navigate = useNavigate();

    const [comments, setComments] = useState<CommentBouldersSector[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (user && currentGym) {
            setIsLoading(true);
            getGymComments(currentGym.id).then(data => {
                setComments(data);
                setIsLoading(false);
            });
        } else {
            if (!localStorage.getItem('user')) {
                navigate('/login-pro');
            }
            console.error("user not provided");
            setIsLoading(false);
        }
    }, [user, currentGym]);

    return {
        comments,
        isLoading,
    };
}
